'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {SlideBar} from './SlideBar.js';
import {UiComponent} from '../ui/UiComponent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';

const privateMap = util.createPrivateMapper();

class ViewObject {
  constructor(idx, view){
    const domEl = document.createElement('div');
    domUtil.asAbsolute(domEl);
    this.domEl = domEl;
    this.index = idx;
    this.view = view;
  }
};

function calculateRange(position, viewRange, gridLines, tileSize){
  const from = Math.floor(position) * gridLines;
  const vl = Math.ceil(viewRange + (position - from / gridLines)) * gridLines;
  const to = Math.min(from + vl, tileSize);
  return [from, to];
}

function relocateTile(pv){
  const sliderSize = domUtil.getSize(pv.sliderContainer);
  const size = pv.size;
  const gridSize = pv.gridSize;
  let prePos = 0;
  if (!pv.slider.isDisabled()) {
    prePos = pv.slider.getPosition() * pv.gridLines;
  }

  gridSize.x = pv.baseGridSize.x;
  gridSize.y = pv.baseGridSize.y;
  if (pv.direction == 'H') {
    if (size.y < pv.baseGridSize.y) {
      gridSize.y = size.y;
      gridSize.x = size.y * (pv.baseGridSize.x / pv.baseGridSize.y);
    }
  } else {
    if (size.x < pv.baseGridSize.x) {
      gridSize.x = size.x;
      gridSize.y = size.x * (pv.baseGridSize.y / pv.baseGridSize.x);
    }
  }

  let sz;
  let listSize;
  if (pv.viewObjs.length > 0) {
    const l = pv.viewObjs.length;
    for (let i = 0; i < l; i++) {
      domUtil.setSize(pv.viewObjs[i].domEl, gridSize);
    }
    if (pv.direction == 'H') {
      // sz = size.sub(0, sliderSize.y);
      sz = size;
      pv.gridLines = Math.min(Math.max(1, Math.floor((sz.y) / gridSize.y)), pv.viewObjs.length);
      pv.gridNum = Math.ceil(pv.viewObjs.length / pv.gridLines);
      const gsz = new Point2D(size.x, pv.gridLines * gridSize.y);
      pv.viewRange = size.x / gridSize.x;
      listSize = new Point2D(Math.min(gsz.x, pv.gridNum * gridSize.x), gsz.y);
      domUtil.setSize(pv.listContainer, new Point2D(pv.gridNum * gridSize.x, pv.gridLines * gridSize.y));
      pv.positionMargin = Math.max(0, (sz.x - pv.gridNum * gridSize.x) / 2);
      domUtil.setPosition(pv.listContainer, new Point2D(pv.positionMargin, (sz.y - gsz.y) / 2));
      if (!pv.reverseOrder) {
        const l = pv.viewObjs.length;
        for (let i = 0; i < l; i++) {
          const x = Math.floor(i / pv.gridLines) * gridSize.x;
          const dy = i % pv.gridLines;
          const y = (pv.reverseLine ? pv.gridLines - dy - 1 : dy) * gridSize.y;
          domUtil.setPosition(pv.viewObjs[i].domEl, new Point2D(x, y));
        }
      } else {
        const l = pv.viewObjs.length;
        for (let i = 0; i < l; i++) {
          const x = (pv.gridNum - Math.floor(i / pv.gridLines) - 1) * gridSize.x;
          const dy = i % pv.gridLines;
          const y = (pv.reverseLine ? pv.gridLines - dy - 1 : dy) * gridSize.y;
          domUtil.setPosition(pv.viewObjs[i].domEl, new Point2D(x, y));
        }
      }
    } else {
      // sz = size.sub(sliderSize.x, 0);
      sz = size;
      pv.gridLines = Math.min(Math.max(1, Math.floor((sz.x) / gridSize.x)), pv.viewObjs.length);
      pv.gridNum = Math.ceil(pv.viewObjs.length / pv.gridLines);
      const gsz = new Point2D(pv.gridLines * gridSize.x, size.y);
      pv.viewRange = size.y / gridSize.y;
      listSize = new Point2D(gsz.x, Math.min(gsz.y, pv.gridNum * gridSize.y));
      domUtil.setSize(pv.listContainer, new Point2D(pv.gridLines * gridSize.x, pv.gridNum * gridSize.y));
      pv.positionMargin = Math.max(0, (sz.y - pv.gridNum * gridSize.y) / 2);
      domUtil.setPosition(pv.listContainer, new Point2D((sz.x - gsz.x) / 2, pv.positionMargin));
      if (!pv.reverseOrder) {
        const l = pv.viewObjs.length;
        for (let i = 0; i < l; i++) {
          const y = Math.floor(i / pv.gridLines) * gridSize.y;
          const dx = i % pv.gridLines;
          const x = (pv.reverseLine ? pv.gridLines - dx - 1 : dx) * gridSize.x;
          domUtil.setPosition(pv.viewObjs[i].domEl, new Point2D(x, y));
        }
      } else {
        const l = pv.viewObjs.length;
        for (let i = 0; i < l; i++) {
          const y = (pv.gridNum - Math.floor(i / pv.gridLines) - 1) * gridSize.y;
          const dx = i % pv.gridLines;
          const x = (pv.reverseLine ? pv.gridLines - dx - 1 : dx) * gridSize.x;
          domUtil.setPosition(pv.viewObjs[i].domEl, new Point2D(x, y));
        }
      }
    }
  } else {
    sz = size.sub(0, sliderSize.y);
    pv.gridLines = 0;
    pv.gridNum = 0;
    pv.viewRange = size.x / gridSize.x;
    listSize = new Point2D(0, 0);
    domUtil.setSize(pv.listContainer, listSize);
    domUtil.setPosition(pv.listContainer, new Point2D(sz.x / 2, sz.y / 2));
  }
  domUtil.setSize(pv.eventLayer, sz);

  pv.minPosition = 0;
  pv.maxPosition = pv.gridNum - pv.viewRange;
  pv.slider.setTerms({
    min: 0,
    max: pv.gridNum,
    cursorRange: pv.viewRange
  });
  pv.slider.applySize();
  if (pv.slider.isDisabled()) {
    pv.position = 0;
  } else {
    pv.slider.setPosition(prePos / pv.gridLines, true);
  }
};

function flushTiles(pv){
  const ncur = {};
  if (pv.viewObjs.length > 0) {
    // doRange(flushCell);

    // const r = doRange();
    const r = pv.rangeConverter(calculateRange(pv.position, pv.viewRange, pv.gridLines, pv.viewObjs.length));
    pv.setListPosition();

    let s;
    let e;
    if (r[0] < r[1]) {
      s = r[0];
      e = r[1];
    } else {
      s = r[1];
      e = r[0];
    }
    e = Math.min(pv.viewObjs.length, e);
    const selectedMap = {}
    for (let selIdx of pv.selectedTiles) {
      selectedMap[selIdx] = true
    }
    for (let i = s; i < e; i++) {
      const so = pv.viewObjs[i];
      if (!so) {
        continue;
      }
      pv.currentObjs['i' + i] = undefined;
      ncur['i' + i] = so;
      const domEl = so.domEl;
      pv.listContainer.appendChild(domEl);
      // domEl.show();

      if (!so.loaded) {
        so.loaded = true;
        ((so) => {
          so.loadingObj = pv.loadView(so, this);
        })(so);
        if (!so.loadingObj.loaded()) {
          so.loadingObj.load();
        }
      };
    }
  }
  for (let i in pv.currentObjs) {
    const so = pv.currentObjs[i];
    if (!so) {
      continue;
    }
    if (so.loadingObj) {
      if (!so.loadingObj.loaded()) {
        // so.loaded = false;
        // so.loadingObj.abort();
      }
    }
    pv.listContainer.removeChild(so.domEl);
  }
  pv.currentObjs = ncur;
};

class DragObj {
  constructor(){
  }

  start(pv, ev, touch){
    if (pv.slider.isDisabled()) {
      return false;
    }
    ev.preventDefault();
    ev.stopPropagation();
    pv.stopAnimation();
    this.draged = false;
    this.base = touch.center;
    this.basePosition = pv.position;
    this.velocity = 0;
    this.direction = 0;
    this.preDirection = 0;
    this.prePx = 0;
    this.preTime = (new Date()).getTime();
    if (pv.direction == 'H') {
      this.prePx = this.base.x;
    } else {
      this.prePx = this.base.y;
    }
    return true;
  }

  drag(pv, e, touch){
    const pt = touch.center;
    const delta = (pt).sub(this.base);
    const now = (new Date()).getTime();

    if (pv.slider.isDisabled()) {
      return;
    }
    e.preventDefault();
    if (delta.distance() > 0) {
      this.draged = true;
    }

    let px;
    if (pv.direction == 'H') {
      px = pt.x;
      this.position = this.basePosition - (delta.x / pv.gridSize.x);
    } else {
      px = pt.y;
      this.position = this.basePosition - (delta.y / pv.gridSize.y);
    }
    pv.slider.setPosition(this.position);

    this.preVelocity = this.velocity;
    this.preDirection = this.direction;
    this.direction = 0;
    this.velocity = 0;
    let dpx = 0;
    let dt = 0;

    dpx = px - this.prePx;
    dt = now - this.preTime;
    this.direction = this.prePx < px ? -1 : 1;
    if (Math.abs(dpx) > 5) {
      if (dt == 0) {
        this.velocity = 2.5;
      } else {
        this.velocity = Math.min(2.5, Math.abs(dpx / dt));
      }
    }
    this.prePx = px;
    this.preTime = now;
  }

  end(pv, e, touch){
    const startTime = (new Date()).getTime();
    const basePosition = pv.position;

    const dir = this.preDirection != this.direction ? this.preDirection : this.direction;
    const initialVelocity = this.preDirection != this.direction ? this.preVelocity : this.velocity;

    if (pv.slider.isDisabled() || !this.draged || initialVelocity == 0) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (startTime - this.preTime > 100) {
      return;
    }
    let pixelUnit;
    if (pv.direction == 'H') {
      pixelUnit = pv.gridSize.x;
    } else {
      pixelUnit = pv.gridSize.y;
    }
    const acceleration = initialVelocity / 1000;
    pv.startAnimation({
      abort: function(){
        this.aborted = true;
      },
      process: function() {
        if (this.aborted) {
          return false;
        }
        const t = (new Date()).getTime();
        const dt = (t - startTime);
        const sp = initialVelocity - acceleration * dt;

        if (sp < 0) {
          return false;
        }
        const dist = initialVelocity * dt - (initialVelocity - sp) * dt / 2;
        const delta = dist / pixelUnit;
        const pp = pv.slider.getPosition();
        pv.slider.setPosition(basePosition + delta * dir);
        const p = pv.slider.getPosition();
        if (pp == p) {
          return false;
        }
        return true;
      }
    });
  }
}

export class TileView extends UiComponent {
  constructor(domEl, argOptions){
    super(domEl);
    const pv = privateMap(this);
    const _self = this;
    const options = util.merge({
      gridSize: new Point2D(200, 150),
      direction: 'H',
      useMousewheel: true
    }, argOptions);

    pv.viewObjs = [];
    pv.listContainer = domUtil.createElement('div');
    pv.sliderContainer = options.slideBarEl ? options.slideBarEl : domUtil.createElement('div');
    pv.eventLayer = domUtil.createElement('div');
    pv.initView = options.initView

    const slideBarOptions = options.slideBarOptions ? options.slideBarOptions : {};
    pv.slider = new SlideBar(pv.sliderContainer, slideBarOptions);
    pv.size = new Point2D();

    pv.positionMargin = 0;
    pv.position = 0;
    pv.gridNum = 1;
    pv.gridLines = 1;
    pv.viewRange = 0;
    pv.minPosition = 0;
    pv.maxPosition = 0;
    pv.selectedTiles = [];

    pv.baseGridSize = new Point2D(options.gridSize);
    pv.gridSize = new Point2D(pv.baseGridSize);
    pv.direction = options.direction ? options.direction : 'H';
    pv.reverseOrder = options.reverseOrder ? options.reverseOrder : false;
    pv.reverseLine = options.reverseLine ? options.reverseLine : false;

    domUtil.asAbsolute(pv.listContainer);
    domUtil.noBoundary(pv.listContainer);
    domUtil.asAbsolute(pv.eventLayer);
    domUtil.noBoundary(pv.eventLayer);
    pv.eventLayer.appendChild(pv.listContainer);
    domEl.appendChild(pv.eventLayer);
    // domEl.appendChild(pv.sliderContainer);
    domUtil.setStyle(domEl, 'overflow', 'hidden');

    pv.loadView = options.loadView ? options.loadView : (tileObj, tileView) => {
      return {
        loaded: function(){
          return true;
        },
        load: function(){
        }
      }
    };

    // pv.positionConverter
    // pv.rangeConverter
    // pv.setListPosition
    pv.constructGridLayoutLogic = () => {
      if (pv.reverseOrder) {
        pv.positionConverter = function(p){
          let r = (pv.gridNum - p - 1);
          return r;
        };
        pv.rangeConverter = function(v){
          // console.log(v);
          const sl = pv.viewObjs.length;
          const sp = sl % pv.gridLines;
          const rp = sl - v[1];
          const ret = [];
          const dt = sp == 0 ? 0 : pv.gridLines - sp;
          if (rp == 0) {
            ret[0] = 0;
            ret[1] = dt + (v[1] - v[0]);
          } else {
            ret[0] = rp + dt;
            ret[1] = rp + dt + (v[1] - v[0]);
          }
          return ret;
        };
      } else {
        pv.positionConverter = function(p){
          return p;
        };
        pv.rangeConverter = function(v){
          return v;
        };
      }
      if (pv.direction == 'H') {
        pv.setListPosition = function(){
          domUtil.setLeft(pv.listContainer, pv.positionMargin - pv.position * pv.gridSize.x);
        }
      } else {
        pv.setListPosition = function(){
          domUtil.setTop(pv.listContainer, pv.positionMargin - pv.position * pv.gridSize.y);
        }
      }
    };
    pv.constructGridLayoutLogic();

    pv.currentObjs = {};
    pv.flush = () => {
      flushTiles.call(this, pv);
    };

    pv.relocate = () => {
      relocateTile.call(this, pv);
      pv.flush();
    }

    let animation;
    let animationTimeout = false;
    pv.stopAnimation = function(){
      if (animation) {
        animation.abort();
        animation = null;
      }
    };
    const processAnimation = function(){
      if (animation) {
        if (animation.process()) {
          animationTimeout = requestAnimationFrame(processAnimation);
        } else {
          animation = null;
          animationTimeout = false;
        }
      }
      animationTimeout = false;
    }
    pv.startAnimation = function(a){
      pv.stopAnimation();
      animation = a;
      if (animation && !animationTimeout) {
        animationTimeout = requestAnimationFrame(processAnimation);
      }
    };

    pv.dragHandler = (function(){
      const d = new DragObj();
      const mousemoveHandler = function(ev){
        d.drag(pv, ev, {center: new Point2D(ev.clientX, ev.clientY)});
      };
      const mouseupHandler = function(ev){
        domUtil.removeEventListener(window, 'mousemove', mousemoveHandler);
        domUtil.removeEventListener(window, 'mouseup', mouseupHandler);
        d.end(pv, ev, {center: new Point2D(ev.clientX, ev.clientY)});
      };
      return function(ev){
        if (!d.start(pv, ev, {center: new Point2D(ev.clientX, ev.clientY)})) {
          return;
        }
        domUtil.addEventListener(window, 'mousemove', mousemoveHandler);
        domUtil.addEventListener(window, 'mouseup', mouseupHandler);
      }
    })();
    domUtil.addEventListener(pv.eventLayer, 'mousedown', pv.dragHandler);

    if (options.useMousewheel) {
      pv.mousewheelHandler = function(e){
        const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        const scrollDiff = pv.viewRange / 3;
        e.preventDefault();
        if (delta < 0) {
          pv.slider.setPosition(pv.position + scrollDiff);
        } else {
          pv.slider.setPosition(pv.position - scrollDiff);
        }
      };
      domUtil.addEventListener(pv.eventLayer, 'mousewheel', pv.mousewheelHandler);
    }

    domUtil.addEventListener(pv.slider.domEl, 'ui.change', function(){
      const pos = pv.slider.getPosition();
      pv.position = Math.max(pv.minPosition, Math.min(pv.maxPosition, pos));
      pv.flush();
    });

    this.applySize();
  }

  get selectedTiles(){
    return privateMap(this).selectedTiles;
  }

  get gridSize() {
    return privateMap(this).baseGridSize;
  }

  get direction() {
    return privateMap(this).direction;
  }
  set direction(direction){
    privateMap(this).direction = direction;
  }

  get reverseOrder() {
    return privateMap(this).reverseOrder;
  }
  set reverseOrder(reverseOrder){
    privateMap(this).reverseOrder = reverseOrder;
  }

  get reverseLine() {
    return privateMap(this).reverseLine;
  }
  set reverseLine(reverseLine){
    privateMap(this).reverseLine = reverseLine;
  }

  hasScroll(){
    const pv = privateMap(this);
    if (pv.slider) {
      return !pv.slider.isDisabled();
    }
    return true;
  };

  getTileObject(idx){
    const pv = privateMap(this);
    return pv.viewObjs[idx];
  }
  addTiles(tiles) {
    const pv = privateMap(this);
    const l = tiles.length;
    util.each(tiles, (tile) => {
      const idx = pv.viewObjs.length;
      const viewObj = new ViewObject(idx, tile);
      pv.viewObjs[idx] = viewObj
      if (pv.initView) {
        pv.initView(viewObj)
      }
    });
    pv.relocate();
  }
  clearTiles(){
    const pv = privateMap(this);
    if (pv.viewObjs.length == 0) {
      return;
    }
    // const l = viewObjs.length;
    // for (let i = 0; i < l; i++) {
    //   viewObjs[i].destroy();
    // }
    pv.viewObjs = [];
    pv.relocate();
    domUtil.empty(pv.listContainer);
    pv.slider.setTerms({
      min: 0,
      max: 0,
      cursorRange: 0
    });
    pv.slider.setPosition(0);
  }

  applySize(){
    const pv = privateMap(this);
    pv.size = domUtil.getSize(this.domEl);
    pv.relocate();
  }

  updateLayout(){
    const pv = privateMap(this);
    pv.size = domUtil.getSize(this.domEl);
    pv.slider.direction = pv.direction;
    pv.constructGridLayoutLogic();
    pv.relocate();
  }

  scroll(v){
    const pv = privateMap(this);
    const fromPos = pv.slider.getPosition();
    const toPos = Math.max(pv.minPosition, Math.min(pv.maxPosition, fromPos + v * pv.viewRange));
    const startTime = (new Date()).getTime();
    const dur = 300;

    if (fromPos == toPos) {
      pv.slider.setPosition(toPos);
      return;
    }
    pv.startAnimation({
      abort: function(){
        this.aborted = true;
      },
      process: function() {
        if (this.aborted) {
          return false;
        }
        const t = (new Date()).getTime();
        const dt = (t - startTime) / dur;

        if (dt > 1) {
          pv.slider.setPosition(toPos);
          return false;
        }
        pv.slider.setPosition(fromPos + (toPos - fromPos) * (1 - Math.abs(1 - dt) * Math.abs(1 - dt)));
        return true;
      }
    });
  }

  selectTiles(argIdxs, useAnimation){
    const pv = privateMap(this);
    const idxMap = {};
    const unchangedIdxMap = {};
    const idxs = []
    if (argIdxs) {
      argIdxs.forEach(idx => {
        if (typeof(idx) != 'number' || idx < 0 || idx >= pv.viewObjs.length) {
          return
        }
        idxs.push(idx)
        idxMap[idx] = true;
      })
    }
    pv.selectedTiles.forEach(idx => {
      if (idxMap[idx]) {
        unchangedIdxMap[idx] = true;
        return;
      }
      const nd = pv.viewObjs[idx];
      if (!nd) {
        return;
      }
      domUtil.dispatchEvent(nd.domEl, 'ui.selectionchanged', {
        detail: false
      });
    });
    pv.selectedTiles.length = 0;
    if (!idxs.length) {
      return;
    }
    let total = 0;
    idxs.forEach(idx => {
      total += Math.floor(idx / pv.gridLines);
      pv.selectedTiles.push(idx);

      if (unchangedIdxMap[idx]) {
        return;
      }
      const nd = pv.viewObjs[idx];
      domUtil.dispatchEvent(nd.domEl, 'ui.selectionchanged', {
        detail: true
      });
    });
    const average = total / idxs.length;

    const toPos = pv.positionConverter(average) - pv.viewRange / 2 + 0.5;
    const fromPos = pv.slider.getPosition();
    const startTime = (new Date()).getTime();
    const dur = 300;

    // domUtil.dispatchEvent(this.domEl, 'ui.select', {
    //   detail: [...pv.selectedTiles]
    // })
    if (!useAnimation || fromPos == toPos) {
      pv.slider.setPosition(toPos);
      return;
    }
    pv.startAnimation({
      abort: function(){
        this.aborted = true;
      },
      process: function() {
        if (this.aborted) {
          return false;
        }
        const t = (new Date()).getTime();
        const dt = (t - startTime) / dur;

        if (dt > 1) {
          pv.slider.setPosition(toPos);
          return false;
        }
        pv.slider.setPosition(fromPos + (toPos - fromPos) * (1 - Math.abs(1 - dt) * Math.abs(1 - dt)));
        return true;
      }
    });
  }
  selectTile(idx, useAnimation){
    const pv = privateMap(this);
    const idxs = [];
    if (idx >= 0 && idx < pv.viewObjs.length) {
      idxs.push(idx);
    }
    this.selectTiles(idxs, useAnimation);
  }
  selectTilesByRange(fromIdx, length, useAnimation){
    const pv = privateMap(this);
    const idxs = [];
    if (fromIdx >= 0) {
      const l = Math.min(length, pv.viewObjs.length - fromIdx);
      for (let i = 0; i < l; i++) {
        idxs.push(fromIdx + i);
      }
    }
    this.selectTiles(idxs, useAnimation);
  }
};
